module.exports = __webpack_public_path__ + "static/media/h05.85c92d47.webp";